"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = App;

var _App = require("@adobe/react-spectrum-workflow/dist/App");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function App(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_App.A4uApp, null));
}